import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
import ReactSlider from "react-slider";
export const Slider = styled(ReactSlider).withConfig({
  displayName: "Slider",
  componentId: "sc-1vjn1jj-0"
})(["width:100%;height:20px;"]);
const StyledThumb = styled.div.withConfig({
  displayName: "Slider__StyledThumb",
  componentId: "sc-1vjn1jj-1"
})(["height:20px;width:20px;background:", ";color:#fff;border-radius:50%;cursor:grab;"], UiConstants.COLOR_SELECTION_HIGHLIGHT);
const StyledTrack = styled.div.withConfig({
  displayName: "Slider__StyledTrack",
  componentId: "sc-1vjn1jj-2"
})(["top:0;bottom:0;background:", ";border-radius:999px;"], UiConstants.COLOR_DARK_BUTTON);
export const SliderTrack = (props, state) => /*#__PURE__*/React.createElement(StyledTrack, _extends({}, props, {
  index: state.index
}));
export const SliderThumb = props => /*#__PURE__*/React.createElement(StyledThumb, props);